import React, { FC } from "react";

import style from "./FullWidthLayout.module.scss";

export interface FullWidthLayoutProps {
    children?: JSX.Element[] | JSX.Element;
}

/**
 * The standard page layout: full width, padded, and the scroll container a PageHeader sticks to.
 */
export const FullWidthLayout: FC<FullWidthLayoutProps> = (props) => (
    <div className={style.layout} data-layout="full">
        {props.children}
    </div>
);
